export default __webpack_public_path__ + "static/media/0xaa7dbd1598251f856c12f63557a4c4397c253cea.4c80e094.jpeg";